import React from "react";

const CandidateAutoApproveBankCandidateIcon = ({ cls }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M16.6818 3.95432L14.0457 1.31818C13.1952 0.468469 12.065 0.000488281 10.8636 0.000488281H7.13546C5.93401 0.000488281 4.80381 0.468469 3.95335 1.31818L1.31721 3.95432C0.467492 4.80479 -0.000488281 5.93499 -0.000488281 7.13644V10.8645C-0.000488281 12.066 0.467492 13.1962 1.31721 14.0467L3.95335 16.6828C4.80381 17.5325 5.93401 18.0005 7.13546 18.0005H10.8636C12.065 18.0005 13.1952 17.5325 14.0457 16.6828L16.6818 14.0467C17.5315 13.1962 17.9995 12.066 17.9995 10.8645V7.13644C17.9995 5.93499 17.5315 4.80479 16.6818 3.95432ZM16.4996 10.8638C16.4996 11.6648 16.1876 12.4185 15.6214 12.9854L12.9852 15.6208C12.4182 16.1878 11.6653 16.4998 10.8636 16.4998H7.13546C6.3345 16.4998 5.58078 16.1878 5.0138 15.6216L2.37841 12.9854C1.81144 12.4185 1.49945 11.6655 1.49945 10.8638V7.13569C1.49945 6.33472 1.81144 5.58101 2.37766 5.01403L5.0138 2.37864C5.58078 1.81166 6.33375 1.49968 7.13546 1.49968H10.8636C11.6645 1.49968 12.4182 1.81166 12.9852 2.37789L15.6206 5.01403C16.1876 5.58101 16.4996 6.33397 16.4996 7.13569V10.8638ZM13.7494 6.31373C14.0427 6.60696 14.0427 7.08094 13.7494 7.37418L9.8256 11.298C9.36587 11.7577 8.75465 12.0112 8.10442 12.0112C7.4542 12.0112 6.84298 11.7577 6.38325 11.298L4.29308 9.20786C3.99985 8.91462 3.99985 8.44064 4.29308 8.1474C4.58632 7.85416 5.0603 7.85416 5.35354 8.1474L7.4437 10.2376C7.79694 10.5908 8.41266 10.59 8.76515 10.2376L12.689 6.31373C12.9822 6.02049 13.4562 6.02049 13.7494 6.31373Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CandidateAutoApproveBankCandidateIcon;
